import React, { Fragment } from "react";
//import PropTypes from "prop-types";

//import { ageSeconds } from "../helpers/utilities";

import "../styles/Memoryform.css";
import translate from "../services/translate";

const MemoryformLifeform = ({ id, mem, register, errors }) => {
  let shortHoldTime = new Date((new Date(mem.shortHoldTime).getTime())/1000);
  let nearDeathTime = new Date((new Date(mem.nearDeathTime).getTime())/1000);
  let birth = new Date(Number(mem.lifeform.birth));
  let death = new Date(Number(mem.lifeform.death));
  console.log(mem.lifeform.birth);
  console.log(death)
  return (
    <div className="mLifeform">
      {mem.created ? <p>{`You created Lifeform #${id} on ${birth.toDateString()}${mem.interactionCount > 1 ? ` and cared for it ${mem.interactionCount === 2 ? `one other time.` : `${mem.interactionCount} other times.`}` : ``}`}</p>
      : <p>{`You cared for Lifeform #${id}${mem.interactionCount > 1 ? ` ${mem.interactionCount} times.` : ` only once.`}`}</p>}
      {mem.killed ? <p>{`Lifeform #${id} also died in your care, on ${death.toDateString()}`}</p> : null}
      {mem.nearDeathExperience ? 
        <Fragment>
        <p>Lifeform #{id} had a near-death experience in your care. On {nearDeathTime.toDateString()} you gave it away with only {Math.round((parseInt(mem.nearDeathDuration)/3600000000) * 100) / 100} hours to spare. Do you remember what happened?</p>
        <input className="text" {...register(`near-${id}`, { pattern: /^[\x00-\x7F]*$/ })} id={`near-${id}`} />
        </Fragment>
        : null}
      {mem.shortHold ? 
        <Fragment>
        <p>On {shortHoldTime.toDateString()} Lifeform #{id} was only with you for {Math.round((parseInt(mem.shortHoldDuration)/60000) * 100) / 100} minutes. Do you remember what happened?</p>
        <input className="text" {...register(`short-${id}`, { pattern: /^[\x00-\x7F]*$/ })} id={`short-${id}`} />
        </Fragment>
        : null}
      {mem.lifeform.archetypes.length > 0 ? (
                <p>Lifeform #{id} {mem.lifeform.archetypes.length > 1 ? " had the archetypes" : "was a"}: 
                  {mem.lifeform.archetypes.map((i) => {
                      return (
                        <Fragment key={i}>
                        <a key={i.id} className="carePat" data-tooltip-id="memformtippy" data-tooltip-content={translate(`archetypes.${[i]}`)}>
                          {` ${i}${mem.lifeform.archetypes[mem.lifeform.archetypes.length-1] === i ? "" : ", "}`}
                        </a>
                        </Fragment>
                      )
                  })
                }</p>) : null}
      <p>Did Lifeform #{id} have a name?</p>
      <input className="text" {...register(`text-${id}`, { pattern: /^[\x00-\x7F]*$/ })} id={`name-${id}`} />
      {errors[`text-${id}`] && <p><span className="error">Sorry, only ascii characters allowed</span></p>}
    </div>
  );
};

export default MemoryformLifeform;
